var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97976 7.22357H11.2217C11.6515 7.22357 12 6.89964 12 6.50005C12 6.10047 11.6515 5.77654 11.2217 5.77654H2.97964L7.32717 1.73511C7.63111 1.45256 7.63111 0.99446 7.32717 0.711912C7.02322 0.429363 6.53042 0.429363 6.22647 0.711911L0 6.5L6.22647 12.2881C6.53042 12.5706 7.02322 12.5706 7.32717 12.2881C7.63111 12.0055 7.63111 11.5474 7.32717 11.2649L2.97976 7.22357Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-arrow-icon.b19ee7f51c22fe1f1228b007e99a5e57.svg";